// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import { Alert, AlertTitle, Stack, Typography } from '@mui/material';

/**
 * Minimal, severity-focused rendering.
 *
 * - Each error -> <Alert severity="error">
 * - Each warning -> <Alert severity="warning">
 * - Shows issue.message only
 */
export default function InsufficientData({ data }) {
  const { t } = useTranslation('alarms');
  const warnings = Array.isArray(data?.warnings) ? data.warnings : [];
  const errors = Array.isArray(data?.errors) ? data.errors : [];

  const hasErrors = errors.length > 0;
  const hasWarnings = warnings.length > 0;

  return (
    <Stack spacing={1.5} sx={{ mt: 2 }}>
      {errors.map((issue, idx) => (
        <Alert
          key={`error-${idx}`}
          severity="error"
          variant="outlined"
          sx={{ borderLeftWidth: 4 }}
        >
          <AlertTitle>Error</AlertTitle>
          <Typography
            component="pre"
            sx={{
              m: 0,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              fontSize: 12,
              lineHeight: 1.4,
            }}
          >
            {String(issue?.message ?? 'Unknown error')}
          </Typography>
        </Alert>
      ))}

      {warnings.map((issue, idx) => (
        <Alert
          key={`warning-${idx}`}
          severity="warning"
          variant="outlined"
          sx={{ borderLeftWidth: 4 }}
        >
          <AlertTitle>Warning</AlertTitle>
          <Typography
            component="pre"
            sx={{
              m: 0,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              fontSize: 12,
              lineHeight: 1.4,
            }}
          >
            {String(issue?.message ?? 'Unknown warning')}
          </Typography>
        </Alert>
      ))}

      {!hasErrors && !hasWarnings && (
        <Alert severity="success" variant="outlined">
          <AlertTitle>{t('type.energyXplorerOperations.insufficientData.no_issues_title')}</AlertTitle>
          {t('type.energyXplorerOperations.insufficientData.no_issues_message')}
        </Alert>
      )}
    </Stack>
  );
}
